<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <template v-if="del_yn == 'N'">
            <div class="center">
                <vs-alert title="산책스케줄 공지사항" active="true">
                    {{ noticeData }}
                </vs-alert>
            </div>
        </template>
        <div>
            <a href="./schedule"><vs-button color="dark" type="line">외진스케줄</vs-button></a>
            <a href="./walkschedule"><vs-button color="dark" type="line" class="btn btn-sm">산책스케줄</vs-button></a>
            <a href="./healingcenter"><vs-button color="dark" type="line" class="btn btn-sm">힐링센터</vs-button></a>
        </div>

        <vx-card title="산책 스케줄">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 box-container flex">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>
                    <span class="ml-5 mr-5"
                        >{{ start_date.substring(0, 4) + '-' + start_date.substring(4, 6) + '-' + start_date.substring(6, 8) }} ~
                        {{ end_date.substring(0, 4) + '-' + end_date.substring(4, 6) + '-' + end_date.substring(6, 8) }}</span
                    >
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>
                </div>
            </div>
            <div class="flex justify-end flex-wrap mb-3">
                <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="popupOpen('', '')" />
            </div>
        </vx-card>
        <div class="tb_wrap">
            <div class="tb_box" id="calendarDiv" style="width:100%;overflow-x:auto; height:900px;">
                <table id="schedule" style="max-width:1200px; max-height:550px;" class="border-collapse calendar">
                    <thead>
                        <tr class="fixed_top">
                            <!-- <th class="border border-solid d-theme-border-grey-light text-center table_header" style="width:100px !important; padding:0px 30px!important">시간 / 일</th> -->
                            <th
                                class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                :style="item.substring(6, 8) == now_day ? 'background-color:#439798 !important; color:#fff;z-index:999;' : 'z-index:999;'"
                                v-for="(item, index) in date_list"
                                :key="index"
                                :id="item"
                            >
                                <div style="padding-bottom:5px;">
                                    <b style="font-size:12px;">{{ dayReturn(item) }}</b>
                                    <vs-row vs-type="flex" vs-justify="center">
                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                                            <a href="javascript:void(0)" @click="popupOpen(item)">
                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                            </a>
                                            &nbsp;&nbsp;
                                            <a href="javascript:void(0)" @click="clipCopyConfirm(item)">
                                                <i class="vs-icon notranslate icon-scale feather icon-copy null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                            </a>
                                        </vs-col>
                                    </vs-row>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in calendar_data" :key="index">
                            <td
                                class="border border-solid d-theme-border-grey-light"
                                style="min-width:600px;height:100px;vertical-align:top;padding:0px;"
                                v-for="(schedule_item, schedule_index) in item.YMD.split(',')"
                                :key="schedule_index"
                            >
                                <table class="contentTable" width="100%" cellspacing="0">
                                    <colgroup>
                                        <col width="50" />
                                        <col width="120" />
                                        <col width="200" />
                                        <col width="300" />
                                        <col width="300" />
                                    </colgroup>

                                    <tbody>
                                        <tr v-for="(item_data, item_index) in gridReturn(index, schedule_index)" :key="item_index" :style="item_data.btn_color">
                                            <template v-if="item_data.schedule_seq != false">
                                                <td class="text-center">
                                                    <input type="checkbox" v-model="copyChecked" :value="item_data.schedule_seq" />
                                                </td>
                                                <td>#{{ item_index + 1 }} [{{ item_data.medical_room_number_nm }}]</td>
                                                <td>{{ item_data.patient_username }}</td>
                                                <td>
                                                    <template v-if="item_data.guardian == 'Y'"> 보호자 / {{ item_data.memo }} </template>
                                                    <template v-if="item_data.guardian == 'N'"> {{ item_data.memo }} </template>
                                                </td>
                                                <td class="text-right">
                                                    &nbsp;
                                                    <a href="#" @click="popupmodify(item_data.schedule_seq)">
                                                        <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <a href="javascript:void(0)" @click="deleteConfirm(item_data.schedule_seq)">
                                                        <i class="vs-icon notranslate icon-scale  feather icon-x null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <a href="javascript:void(0)" @click="deleteAllConfirm(item_data.schedule_code)">
                                                        <i class="vs-icon notranslate icon-scale  feather icon-trash null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                                    </a>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- <div class="p-2" v-for="(item_data, item_index) in gridReturn(index, schedule_index)" :key="item_index" :style="item_data.btn_color">
                                    <template v-if="item_data.guardian == 'Y'">
                                        <span
                                            ><b>[{{ item_data.medical_room_number_nm }}] {{ item_data.patient_username }}</b> 보호자 / {{ item_data.memo }}</span
                                        >
                                        <div>
                                            &nbsp;
                                            <a href="#" @click="popupmodify(item_data.schedule_seq)">
                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"></i>
                                            </a>
                                            &nbsp;
                                            <a href="javascript:void(0)" @click="deleteConfirm(item_data.schedule_seq)">
                                                <i class="vs-icon notranslate icon-scale  feather icon-x null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                            </a>
                                            <a href="javascript:void(0)" @click="deleteAllConfirm(item_data.schedule_code)">
                                                <i class="vs-icon notranslate icon-scale  feather icon-trash null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                            </a>
                                        </div>
                                    </template>
                                    <template v-if="item_data.guardian == 'N'"
                                        ><span
                                            ><b>[{{ item_data.medical_room_number_nm }}] {{ item_data.patient_username }}</b> {{ item_data.memo }}</span
                                        >
                                        <div>
                                            &nbsp;
                                            <a href="#" @click="popupmodify(item_data.schedule_seq)">
                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"></i>
                                            </a>
                                            &nbsp;
                                            <a href="javascript:void(0)" @click="deleteConfirm(item_data.schedule_seq)">
                                                <i class="vs-icon notranslate icon-scale  feather icon-x null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                            </a>
                                            <a href="javascript:void(0)" @click="deleteAllConfirm(item_data.schedule_code)">
                                                <i class="vs-icon notranslate icon-scale  feather icon-trash null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                            </a>
                                        </div>
                                    </template>
                                </div> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <vs-popup title="산책 스케줄 등록 및 수정" :active.sync="popupActive">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-input class="w-full" name="schedule_gubun" value="산책스케줄" disabled />
                    </div>
                </div>

                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <label for="" class="vs-input--label">날짜</label>
                        <date-picker name="schedule_start" :locale="'ko'" v-model="schedule_start" valueType="format" class="vs-inputx normal w-full"></date-picker>
                    </div>
                </div>

                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1">
                        <v-select :maxHeight="'50px'" ref="searchInputNew" v-model="schedule_member" :closeOnSelect="true" :options="member_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" @open="resetOption()"/>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1 justify-between">
                    <vs-checkbox v-model="guardian">
                        보호자
                    </vs-checkbox>
                </div>
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-divider color="danger">메모</vs-divider>
                        <vs-textarea class="w-full" name="memo" v-model="schedule_memo" placeholder="메모를 입력해주세요." />
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-checkbox :vs-value="'true'" v-model="autoCheck" @input="autoEvent">반복설정 여부</vs-checkbox>
                    </div>
                </div>

                <template v-if="autoCheck == 'true'">
                    <div class="vx-col w-full lg:w-1/1 mb-base">
                        <hr />
                    </div>

                    <div class="vx-col w-full lg:w-1/1 mb-base">
                        <h5>반복설정</h5>
                    </div>

                    <div class="vx-col w-full lg:w-1/2 mb-base">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-select autocomplete="off" class="w-auto" name="schedule_gubun" v-model="schedule_gubun_type" label="주기옵션" placeholder="주기선택">
                                <vs-select-item :value="1" :text="'일'" />
                                <vs-select-item :value="2" :text="'주'" />
                                <vs-select-item :value="3" :text="'개월'" />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-col w-full lg:w-1/2 mb-base">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-input class="w-full" name="memo" v-model="schedule_gubun_number" label="주기" placeholder="" />
                        </div>
                    </div>

                    <div class="vx-col w-full lg:w-1/1 mb-base" v-if="schedule_gubun_type == '2'">
                        <ul class="centerx">
                            <li>
                                <vs-checkbox :vs-value="'1'" v-model="schedule_week">월</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'2'" v-model="schedule_week">화</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'4'" v-model="schedule_week">수</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'8'" v-model="schedule_week">목</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'16'" v-model="schedule_week">금</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'32'" v-model="schedule_week">토</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'64'" v-model="schedule_week">일</vs-checkbox>
                            </li>
                        </ul>
                    </div>
                    <div class="vx-col w-full lg:w-1/1 mb-base" v-if="schedule_gubun_number == '3'">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-select autocomplete="off" class="w-auto" name="schedule_gubun_day" label="매월(일)주기" v-model="schedule_gubun_days" placeholder="주기선택"> </vs-select>
                        </div>
                    </div>
                    <div class="vx-col w-full lg:w-1/1 mb-base">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-radio vs-value="N" v-model="schdule_endYN">없음</vs-radio>
                        </div>
                        <div class="vx-col w-full lg:w-1/1 ">
                            <ul class="centerx">
                                <li>
                                    <vs-radio vs-value="Y" v-model="schdule_endYN">종료날짜</vs-radio>
                                </li>
                                <li style="padding-left:20px;">
                                    <date-picker name="patientBirthday" :locale="'ko'" v-model="schedule_end" valueType="format" class="vs-inputx normal w-full"></date-picker>
                                </li>
                            </ul>
                        </div>
                        <div class="vx-col w-full lg:w-1/1 "></div>
                    </div>
                </template>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full text-right ">
                    <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" style="width: 120px;" type="button" @click="messageScheduleSave">
                        <span>저장</span>
                    </button>
                    <button class="vs-component vs-button mb-2 vs-button-warning vs-button-border" type="button">
                        <span @click="popupActive = false">닫기</span>
                    </button>
                </div>
            </div>
        </vs-popup>

        <vs-popup title="산책 스케줄 등록 및 수정" :active.sync="popupActiveModify">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-input class="w-full" name="schedule_gubun" value="산책스케줄" disabled />
                    </div>
                </div>

                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <label for="" class="vs-input--label">날짜</label>
                        <date-picker name="schedule_start" :locale="'ko'" v-model="schedule_start" valueType="format" class="vs-inputx normal w-full"></date-picker>
                    </div>
                </div>

                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1">
                        <v-select :maxHeight="'50px'" ref="searchInputModify" v-model="schedule_member" :closeOnSelect="true" :options="member_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" @open="resetOption()"/>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1 justify-between">
                    <vs-checkbox v-model="guardian">
                        보호자
                    </vs-checkbox>
                </div>
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-divider color="danger">메모</vs-divider>
                        <vs-textarea class="w-full" name="memo" v-model="schedule_memo" placeholder="메모를 입력해주세요." />
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full text-right ">
                    <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="button">
                        <span class="mr-3 mb-2" @click="messageScheduleModify">저장</span>
                    </button>
                    <button class="vs-component vs-button mb-2 vs-button-warning vs-button-border" type="button">
                        <span color="warning" @click="popupActiveModify = false">닫기</span>
                    </button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import moment from 'moment';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: {
        DatePicker,
        'v-select': vSelect,
    },
    data() {
        return {
            now_date: '',
            prev_date: '',
            next_date: '',
            list: [],
            now_day: '',
            date_list: [],
            calendar_data: [],
            company_list: [],
            company_list_tmp: [],
            popupActive: false,
            popupActiveModify: false,
            search: '',
            schdule_endYN: 'N',
            schedule_start: '',
            schedule_end: '',
            schedule_time: '',
            schedule_real_time: '',
            schedule_gubun: '',
            schedule_company: '',
            schedule_member: '',
            schedule_week: [],
            schedule_gubun_number: 1,
            schedule_gubun_type: 0,
            schedule_gubun_days: 0,
            member_list: [],
            selected_seq: -1,
            selected_schedule_code: '',
            autoCheck: null,
            schedule_memo: '',
            start_date: '',
            end_date: '',
            guardian: false,
            schedule_cnt: [],
            cnt: [],
            noticeData: '',
            del_yn: '',
            width: window.innerWidth,
            copyChecked: [],
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        prevMonth() {
            this.now_date = this.prev_date;
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.scheduleData(this.now_date);
        },
        nextMonth() {
            this.now_date = this.next_date;
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.scheduleData(this.now_date);
        },
        async scheduleData(date) {
            this.now_day = dateClass.nowday();

            if (date == '') {
                this.now_date = dateClass.dateYYYYMMDD();
            } else {
                this.now_date = date;
            }
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            try {
                const { data } = await axiosClass.get('/api/message/walklist/' + this.now_date, {}, true);
                this.member_list = JSON.parse(data.memberList || '[]');

                if (data.schedule_data && data.schedule_data.length > 0 && data.schedule_data[0].YMD) {
                    this.date_list = data.schedule_data[0].YMD.split(',');
                    this.start_date = this.date_list[0];
                    this.end_date = this.date_list[this.date_list.length - 1];
                    this.calendar_data = data.schedule_data;
                } else {
                    this.date_list = [];
                    this.calendar_data = [];
                }

                this.schedule_cnt = data.schedule_cnt || [];
                this.noticeData = data.noticeData ? data.noticeData['NOTICE'] : '';
                this.del_yn = data.noticeData ? data.noticeData['DEL_YN'] : 'Y';

                console.log(this.schedule_cnt);
            } catch (error) {
                console.error('scheduleData error:', error);
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: '데이터를 불러오는 중 오류가 발생했습니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.date_list = [];
                this.calendar_data = [];
            } finally {
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);
            }

            let nowDate = this.now_date;
            setTimeout(function() {
                var element = document.getElementById(nowDate);

                // element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }, function() {
                //     console.log('이동 완료');
                // });
            }, 500);
        },

        dayReturn(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item.substring(0, 4) + '-' + item.substring(4, 6) + '-' + item.substring(6, 8)).getDay()];
            return parseInt(item.substring(4, 6)) + '월 / ' + parseInt(item.substring(6, 8)) + '일(' + weekString + ')';
        },

        autoEvent() {
            console.log(this.autoCheck);
        },

        async popupmodify(schedule_seq) {
            this.selected_seq = schedule_seq;
            this.popupActiveModify = true;
            console.log('schedule_seq :' + schedule_seq);

            const { data } = await axiosClass.get('/api/message/walkselect/' + this.selected_seq, {}, true);
            console.log(data);
            this.schedule_gubun = '3';

            this.schedule_start = data.selectData.START_YMD.substring(0, 4) + '-' + data.selectData.START_YMD.substring(4, 6) + '-' + data.selectData.START_YMD.substring(6, 10);

            this.schedule_member = data.selectData.PATIENT_UID;
            this.schedule_memo = data.selectData.MEMO;

            this.schedule_company = data.selectData.COMPANY_SCHDULE_CD;
            for (let i = 0; i < this.member_list.length; i++) {
                if (this.member_list[i].id == data.selectData.PATIENT_UID) {
                    this.schedule_member = this.member_list[i];
                    break;
                }
            }
            // this.guardian = data.selectData.GUARDIAN;
            if (data.selectData.GUARDIAN == 'Y') {
                this.guardian = true;
            } else {
                this.guardian = false;
            }
        },

        gridReturn(time_index, day_index, gubun) {
            const data = this.calendar_data[0];
            const schedule_seq = data.SCHEDULE_SEQ.split('///');
            const schedule_code = data.SCHEDULE_CODE.split('///');
            const schedule_gubun = data.SCHEDULE_GUBUN.split('///');

            const patient_uid = data.PATIENT_UID.split('///');
            const patient_username = data.PATIENT_USERNAME.split('///');
            const patient_phone = data.PATIENT_PHONE.split('///');
            const medical_room_number_nm = data.MEDICAL_ROOM_NUMBER_NM.split('///');
            const medical_room_number_cnt = data.MEDICAL_ROOM_NUMBER_CNT.split('///');
            const memo = data.MEMO.split('///');
            const guardian = data.GUARDIAN.split('///');
            const status = data.CD_STATUS.split('///');

            const schedule_seq_temp = schedule_seq[day_index].split(',');
            const schedule_code_temp = schedule_code[day_index].split(',');
            const schedule_gubun_temp = schedule_gubun[day_index].split(',');

            const patient_uid_temp = patient_uid[day_index].split(',');
            const patient_username_temp = patient_username[day_index].split(',');
            const patient_phone_temp = patient_phone[day_index].split(',');
            const medical_room_number_nm_temp = medical_room_number_nm[day_index].split(',');
            const medical_room_number_cnt_temp = medical_room_number_cnt[day_index].split(',');
            const memo_temp = memo[day_index].split(',');
            const guardian_temp = guardian[day_index].split(',');
            const status_temp = status[day_index].split(',');

            const dayArr = [];
            let btn_color = [];
            for (let i = 0; i < schedule_seq_temp.length; i++) {
                if (status_temp[i] == '7') {
                    btn_color[i] = 'background-color:rgba(201,149,164, 0.3);';
                }

                dayArr.push({
                    schedule_seq: schedule_seq_temp[i],
                    schedule_code: schedule_code_temp[i],
                    schedule_gubun: schedule_gubun_temp[i],
                    patient_uid: patient_uid_temp[i],
                    patient_username: patient_username_temp[i],
                    patient_phone: patient_phone_temp[i],
                    medical_room_number_nm: medical_room_number_nm_temp[i],
                    medical_room_number_cnt: medical_room_number_cnt_temp[i],
                    memo: memo_temp[i],
                    btn_color: btn_color[i],
                    guardian: guardian_temp[i],
                    status: status_temp[i],
                });
            }

            return dayArr;
        },

        async memberSearch() {
            const { data } = await axiosClass.get('/api/message/member', { search: this.search }, true);
            this.member_list = data.member_list;
        },

        async popupOpen(ymd) {
            console.log(ymd);
            if (ymd == '') {
                this.schedule_start = '';
            } else {
                this.schedule_start = dateClass.dateYYYYMMDD3(ymd);
            }
            this.autoCheck = null;
            this.schdule_endYN = 'N';

            this.schedule_end = '';
            this.schedule_gubun = '';
            this.schedule_member = '';
            this.schedule_week = [];
            this.schedule_gubun_number = 1;
            this.schedule_gubun_type = 0;
            this.schedule_gubun_days = 0;
            this.schedule_memo = '';
            this.popupActive = true;
            this.guardian = false;
        },

        async deleteConfirm(seq) {
            this.selected_seq = seq;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택하신 산책 스케줄 개별삭제를 하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: this.deleteConfirmProcess,
            });
        },
        async deleteConfirmProcess() {
            const jsonData = {
                seq: this.selected_seq,
            };
            await axiosClass.delete('/api/message/walkone', jsonData, true);

            this.$vs.notify({
                color: 'danger',
                title: '삭제 완료',
                text: '삭제가 완료되었습니다.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            await this.scheduleData(this.now_date);
        },

        async deleteAllConfirm(schedule_seq) {
            this.selected_schedule_code = schedule_seq;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택하신 산책 스케줄 전체삭제 하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: this.deleteConfirmAllProcess,
            });
        },

        async deleteConfirmAllProcess() {
            const jsonData = {
                schedule_code: this.selected_schedule_code,
            };
            await axiosClass.delete('/api/message/walkall', jsonData, true);
            this.$vs.notify({
                color: 'danger',
                title: '삭제 완료',
                text: '삭제가 완료되었습니다.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            await this.scheduleData(this.now_date);
        },

        async popupOpenCode(date, time, code) {
            this.schdule_endYN = 'N';
            this.schedule_start = '';
            this.schedule_end = '';
            this.schedule_time = '';
            this.schedule_gubun = '';
            this.schedule_company = '';
            this.schedule_member = '';
            this.schedule_week = [];
            this.schedule_gubun_number = 1;
            this.schedule_gubun_type = 0;
            this.schedule_gubun_days = 0;

            this.popupActive = true;
            this.schedule_gubun = code;
            await this.schedule_gubunEvent();
            this.schedule_start = moment(date).format('YYYY-MM-DD');
            this.schedule_time = time;
            await this.selectTime();
        },

        async messageScheduleModify() {
            let err_msg = '';
            let week_sum = 0;
            console.log('check Modify:' + this.schedule_member.id);
            if (this.schedule_start == false) {
                err_msg = '날짜를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            if (this.schedule_member.id == false || typeof this.schedule_member.id == 'undefined') {
                err_msg = '환자를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            let guardian_temp = '';

            if (this.guardian == true) {
                guardian_temp = 'Y';
            } else {
                guardian_temp = 'N';
            }
            for (let i = 0; i < this.schedule_cnt.length; i++) {
                let total = 0;
                total = this.schedule_cnt[i]['CNT'] + this.schedule_cnt[i]['GUARDIAN_CNT'];
                if (this.schedule_cnt[i]['YMD'] == dateClass.dateYYYYMMDD2(this.schedule_start)) {
                    if (this.guardian == true) {
                        if (total > 21) {
                            err_msg = '보호자를 포함할 수 없습니다.신청 인원이 초과되어 추가 신청이 불가능 합니다.';
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                text: err_msg,
                                position: 'top-right',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                            });
                            return;
                        }
                    } else {
                        if (total > 22) {
                            err_msg = '신청인원이 초과되어 추가 신청이 불가능 합니다.';
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                text: err_msg,
                                position: 'top-right',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                            });
                            return;
                        }
                    }
                }
            }
            const jsonData = {
                selected_seq: this.selected_seq,
                schedule_gubun: '3',
                schedule_start: this.schedule_start,
                schedule_member: this.schedule_member.id,
                guardian: guardian_temp,
                schedule_memo: this.schedule_memo,
                now_date: this.now_date,
            };

            await axiosClass.post('/api/message/walkmodify', jsonData);

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActiveModify = false;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            await this.scheduleData(this.now_date);
        },

        async messageScheduleSave() {
            let err_msg = '';
            let week_sum = 0;
            console.log('check Save:' + this.schedule_member.id);
            if (this.schedule_start == false) {
                err_msg = '날짜를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            if (this.schedule_member.id == false || typeof this.schedule_member.id == 'undefined') {
                err_msg = '환자를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            for (let i = 0; i < this.schedule_cnt.length; i++) {
                let total = 0;
                total = this.schedule_cnt[i]['CNT'] + this.schedule_cnt[i]['GUARDIAN_CNT'];
                console.log('check:' + total);
                if (this.schedule_cnt[i]['YMD'] == dateClass.dateYYYYMMDD2(this.schedule_start)) {
                    if (this.guardian == true) {
                        if (total > 21) {
                            err_msg = '보호자를 포함할 수 없습니다.신청 인원이 초과되어 추가 신청이 불가능 합니다.';
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                text: err_msg,
                                position: 'top-right',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                            });
                            return;
                        }
                    } else {
                        if (total > 22) {
                            err_msg = '신청인원이 초과되어 추가 신청이 불가능 합니다.';
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                text: err_msg,
                                position: 'top-right',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                            });
                            return;
                        }
                    }
                }
            }

            if (this.schedule_member.id == false) {
                err_msg = '환자를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            if (this.autoCheck == 'true') {
                if (this.schedule_gubun_number == false) {
                    err_msg = '주기를 입력해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }

                if (this.schedule_gubun_type == false) {
                    err_msg = '주기옵션을 선택해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }

                if (this.schedule_gubun_type == 2) {
                    if (this.schedule_week.length == 0) {
                        err_msg = '요일을 선택해주세요.';
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            text: err_msg,
                            position: 'top-right',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        return;
                    } else {
                        for (let i = 0; i < this.schedule_week.length; i++) {
                            week_sum = parseInt(week_sum) + parseInt(this.schedule_week[i]);
                        }
                    }
                }

                if (this.schdule_endYN == 'Y') {
                    if (this.schedule_end == false) {
                        err_msg = '종료날짜를 선택해주세요.';
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            text: err_msg,
                            position: 'top-right',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        return;
                    }
                }
            }
            let guardian_temp = '';

            if (this.guardian == true) {
                guardian_temp = 'Y';
            } else {
                guardian_temp = 'N';
            }

            const jsonData = {
                schedule_gubun: '3',
                schedule_start: this.schedule_start,
                schedule_end: this.schedule_end,
                schedule_member: this.schedule_member.id,
                schedule_gubun_number: this.schedule_gubun_number,
                schedule_gubun_type: this.schedule_gubun_type,
                schedule_gubun_days: this.schedule_gubun_days,
                schedule_memo: this.schedule_memo,
                schedule_week: week_sum,
                authCheck: this.autoCheck,
                schdule_endYN: this.schdule_endYN,
                now_date: this.now_date,
                guardian: guardian_temp,
            };

            this.saveCheck(this.schedule_start);

            await axiosClass.post('/api/message/walksave', jsonData);

            let nowDate = moment().format('YYYYMMDD');
            let selectDate = dateClass.dateYYYYMMDD2(this.schedule_start);

            if(this.now_date == selectDate){
                this.sendKakaoWorkBot();
            }

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            await this.scheduleData(this.now_date);
        },
        async saveCheck(ymd) {
            const selectdate = dateClass.dateYYYYMMDD2(ymd);
            console.log('savecheck' + selectdate);
            const { data } = await axiosClass.get('/api/message/walkcnt/' + selectdate, {}, true);
            console.log(data.cnt['CNT']);
            this.cnt = data.cnt;
        },
        async scheduleGubunDaysChange() {},

        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        async clipCopyConfirm(ymd) {
            // console.log(this.copy_schedule_seq + '///' + ymd + '///' + time);

            this.copy_select_date = ymd;

            if (this.copyChecked.length == 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 컨텐츠를 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택한 스케줄을 복사하시겠습니까?',
                acceptText: '복사',
                cancelText: '취소',
                accept: this.DataCopy,
                cancel: function() {
                    return;
                },
            });
            // document.getElementsByClassName('con-vs-chip').classList.remove('selectOn');
        },
        async DataCopy() {
            const jsonData = {
                copy_date: this.copyChecked,
                ymd: this.copy_select_date,
            };
            console.log(jsonData);

            const { data } = await axiosClass.post('/api/message/walkcopy', jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            await this.scheduleData(this.now_date);
            this.copy_schedule_seq = -1;
        },

        // 2023-05-09 TH 추가
        // 당일 추가된 산책 인원에게 카카오워크 알림톡을 보내는 기능
        async sendKakaoWorkBot() {
            let msgText ='';

            let patientName = this.schedule_member.label;
            msgText = patientName + '님께서 당일 산책 스케쥴을 추가하셨습니다.'
            
            let walkScheduleData = {
                conversationId : 6269751, // 대표원장님, 행정원장님, 관리팀장, 힐링센터팀장, 전산주임이 초대된 외진알림방의 id
                // conversationId : 6269377, // 개발주임만 있는 방 id for test(외진스케쥴탭)
                msgText : msgText,
                fromWhere : 4 // 산책스케쥴일때
            }

            const response = await axiosClass.post('/api/kakaoWork/sendMessages', walkScheduleData, true);
            console.log(response);
        },
        async searchPatient (value) {
            this.member_list = [];

            let params = {
                search_name : value
            }

            if(value != ''){
                const { data } = await axiosClass.get(
                    "/api/patient/search_patientList",
                    params,
                    true
                );
                for (let i = 0; i < data.data.length; i++) {
                    this.member_list.push({
                        id: data.data[i].PATIENT_UID,
                        patientPhone : data.data[i].PATIENT_PHONE,
                        patientName : data.data[i].PATIENT_USERNAME,
                        patientUid : data.data[i].PATIENT_UID,
                        oxygenPoint : data.data[i].OXYGEN_POINT || 0,
                        label: (data.data[i].MEDICAL_ROOM_NM != '' ? data.data[i].MEDICAL_ROOM_NM + '-' + data.data[i].MEDICAL_ROOM_NUMBER_NM + ' : ' : '') + data.data[i].CHART_NO + '/' + data.data[i].PATIENT_USERNAME + '('+ data.data[i].PATIENT_PHONE.substr(9,4) + ')',
                    });
                }
            }

        },
        resetOption () {
            this.member_list=[];
        }
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.scheduleData('');
        this.$nextTick(() => {
            const newInput = this.$refs.searchInputNew && this.$refs.searchInputNew.$el.querySelector("input");
            const modifyInput = this.$refs.searchInputModify && this.$refs.searchInputModify.$el.querySelector("input");
            
            if (newInput) {
                console.log("New input found");
                newInput.addEventListener("keyup", (event) => {
                    if (event.key === "Enter") {
                        this.searchPatient(newInput.value);
                    }
                });
            }
            
            if (modifyInput) {
                console.log("Modify input found");
                modifyInput.addEventListener("keyup", (event) => {
                    if (event.key === "Enter") {
                        this.searchPatient(modifyInput.value);
                    }
                });
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        nowDate() {
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        },
    },
};

window.addEventListener('resize', reportWindowSize);
window.addEventListener('load', reportWindowSize);
function reportWindowSize() {
    document.getElementById('calendarDiv').style.height = document.documentElement.clientHeight - 500 + 'px';
}
</script>

<style>
.calendar tbody tr td {
    border-bottom: 1px dashed #c1c1c1;
    padding: 10px !important;
    font-size: 13px !important;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 11px;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}

.tb_box {
    height: 750px;
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0;
    z-index: 1000;
}

.table_header2 {
    position: sticky;
    top: 20;
    z-index: 1000;
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}

.mx-datepicker-popup {
    z-index: 90000000 !important;
}
.activeMenu {
    border-color: #015666;
}
.tb_box {
    height: 630px;
    overflow: auto;
}
.centerx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.calendarTD .vx-card__body {
    padding: 0px !important;
}

.calendarTD .vx-card__header .vx-card__title h4 {
    font-size: 14px;
}

.calendarTD .vx-card__header {
    padding: 10px;
}

.calendar tbody tr td {
    padding: 5px !important;
    font-size: 11px;
    background-color: #fff;
}

.con-vs-chip {
    float: none !important;
    min-height: 25px !important;
}

.timeHeader {
    position: sticky;
    left: 0;
    z-index: 999;
}

.cTitle {
    padding: 20px;
    width: 100%;
    background-color: #ccc;
}
.tdHeader {
    background-color: #f1f1f1;
}

.border-collapse i {
    font-size: 10px;
}

.border-collapse .includeIconOnly {
    width: 24px !important;
    height: 24px !important;
}
.headerBtn {
    background-color: rgba(241, 241, 241, 0.9);
    padding: 5px 10px;
}
.headerBtn a {
    padding: 5px;
}
</style>
